export default __webpack_public_path__ + "static/media/node-js-logo.a2766b33.jpg";